import type { RouteRecordRaw } from 'vue-router'
import { ADMIN_RBAC_PERMISSIONS } from '@/config/admin/rbac'

export const adminSystemRoutes: RouteRecordRaw[] = [
  {
    path: 'system/base-data',
    name: 'AdminBaseData',
    component: () => import('@/views/admin/system/BaseDataManagementPage.vue'),
    meta: {
      title: '基础数据管理',
      sidebarId: 'base-data',
      permissions: [ADMIN_RBAC_PERMISSIONS.BASE_DATA_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
  {
    path: 'system/settings',
    name: 'AdminSettings',
    component: () => import('@/views/admin/system/AdminSettingsPage.vue'),
    meta: {
      title: '基础设置',
      sidebarId: 'settings',
      permissions: [ADMIN_RBAC_PERMISSIONS.SYSTEM_SETTINGS_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
  {
    path: 'system/home-layout',
    name: 'AdminHomeLayout',
    component: () => import('@/views/admin/system/AdminHomeLayoutPage.vue'),
    meta: {
      title: '首页布局设置',
      sidebarId: 'home-layout',
      permissions: [ADMIN_RBAC_PERMISSIONS.SYSTEM_SETTINGS_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
  {
    path: 'system/client-users',
    name: 'AdminClientUserList',
    component: () => import('@/views/admin/system/AdminClientUserListPage.vue'),
    meta: {
      title: '客户账号',
      sidebarId: 'client-users',
      permissions: [ADMIN_RBAC_PERMISSIONS.SYSTEM_CLIENT_USERS_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
  {
    path: 'system/admins',
    name: 'AdminSystemAdmins',
    component: () => import('@/views/admin/system/AdminUserListPage.vue'),
    meta: {
      title: '后台账号',
      sidebarId: 'admin-users',
      permissions: [ADMIN_RBAC_PERMISSIONS.SYSTEM_ADMINS_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
  {
    path: 'system/permission-logs',
    name: 'AdminPermissionLogList',
    component: () => import('@/views/admin/system/AdminPermissionLogListPage.vue'),
    meta: {
      title: '操作日志',
      sidebarId: 'operation-logs',
      permissions: [ADMIN_RBAC_PERMISSIONS.SYSTEM_PERMISSION_LOGS_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
  {
    path: 'system/announcements',
    name: 'AdminAnnouncements',
    component: () => import('@/views/admin/system/AdminAnnouncementsPage.vue'),
    meta: {
      title: '系统公告',
      sidebarId: 'announcements',
      permissions: [ADMIN_RBAC_PERMISSIONS.SYSTEM_SETTINGS_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
]
